import { ApiSmpGpt, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import produce from "immer";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useQueryGptAgentList } from "@/queries";

type Params = Parameters<typeof ApiSmpGpt.Agent.patch>[0];
type Response = Await<ReturnType<typeof ApiSmpGpt.Agent.patch>>;

export const useMutationGptAgentPatch = (
  options?: UseMutationOptions<Response, FailureApi, Params>,
) => {
  const queryClient = useQueryClient();

  return useMutation<Response, FailureApi, Params>(
    (variables) => ApiSmpGpt.Agent.patch(variables),
    {
      ...options,
      onSuccess: (...args) => {
        const updatedAgent = args[0];

        queryClient.setQueriesData<
          ReturnType<typeof useQueryGptAgentList>["data"]
        >(
          useQueryGptAgentList.KEY,
          produce((draft) => {
            draft?.pages.forEach((page) => {
              page.results.forEach((agent) => {
                if (agent.id === updatedAgent.id) {
                  agent.context = updatedAgent.context;
                  agent.params = updatedAgent.params;
                }
              });
            });
          }),
        );

        options?.onSuccess?.(...args);
      },
    },
  );
};
